module.exports = __webpack_public_path__ + "static/media/listus-logo-w.8521f483.png";